import { ChevronLeft, ChevronRight } from "lucide-react";

// Simple client-side pagination control. The caller filters/searches over the
// FULL list first, then slices the filtered result for the current page —
// so search always covers everything, and only rendering is paged.
export default function Pagination({ page, pageSize, total, onPageChange, onPageSizeChange, pageSizeOptions = [25, 50, 100] }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const clampedPage = Math.min(page, totalPages);
  const from = total === 0 ? 0 : (clampedPage - 1) * pageSize + 1;
  const to = Math.min(total, clampedPage * pageSize);

  if (total === 0) return null;

  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", borderTop: "1px solid var(--border)", flexWrap: "wrap", gap: 10 }} data-testid="pagination">
      <div style={{ fontSize: 13, color: "var(--text-muted)" }}>
        Showing <strong>{from}</strong>–<strong>{to}</strong> of <strong>{total}</strong>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {onPageSizeChange && (
          <select
            className="select"
            data-testid="pagination-page-size"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            style={{ height: 32, fontSize: 13 }}
          >
            {pageSizeOptions.map((n) => <option key={n} value={n}>{n} / page</option>)}
          </select>
        )}
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <button
            className="btn btn-ghost btn-sm"
            data-testid="pagination-prev"
            onClick={() => onPageChange(clampedPage - 1)}
            disabled={clampedPage <= 1}
          >
            <ChevronLeft size={14}/>
          </button>
          <span style={{ fontSize: 13, minWidth: 70, textAlign: "center" }}>Page {clampedPage} / {totalPages}</span>
          <button
            className="btn btn-ghost btn-sm"
            data-testid="pagination-next"
            onClick={() => onPageChange(clampedPage + 1)}
            disabled={clampedPage >= totalPages}
          >
            <ChevronRight size={14}/>
          </button>
        </div>
      </div>
    </div>
  );
}
